import { IId } from '~/src/figure/Item';
import { P2 } from '~/src/geometry/point';
import * as Pnt from '~/src/geometry/point';
import * as Vec from '~/src/geometry/vector';
import { get1, set } from '~/src/base/Optic';

import State from '../State';
import * as St from '../State';
import { getRuler } from './Utils';
import { _Info, direction, Ruler } from '~/src/figure/Ruler';
import { V3 } from '~/src/geometry/vector';
import { _Layer } from '~/src/figure/RulerInfo';


export interface MoveRulerLabel {
	tag : 'MoveRulerLabel';
	rid : IId;
	pnt : P2;
}

export const moveRulerLabel = ( rid : IId , pnt : P2 ) : MoveRulerLabel =>
	( { tag : 'MoveRulerLabel' , rid , pnt } );

export const exeMoveRulerLabel = ( state : State , cmd : MoveRulerLabel ) : State => {
	const zoom : number = get1( St.zoom )( state );
	const ruler : undefined | Ruler = getRuler( cmd.rid )( state.figure );
	const project = St._project( get1( St.angle )( state ) );
	const normalize = St._normalize( get1( St.pan )( state ) )( zoom );

	if ( !ruler ) return state;

	const dir_v : V3 = direction( 32 / zoom )( ruler );

	const layer_offset = project( Pnt.p( dir_v ) );
	const left = project( ruler.For.Left );
	const target = normalize( Pnt.p( cmd.pnt ) );
	const layers = Vec.firstBasis( Vec.sub( target )( left ) )( layer_offset );
	const ruler_layer : number = get1( St.rulerLayer( cmd.rid ) )( state ) ?? 0;

	return set( St.rulerLabelLayer( cmd.rid ) )( layers - ruler_layer )( state );
};
